export default function BackModule({ setTab, label }: { setTab: (tab: string) => void, label: string }) {

    const backTo = localStorage.getItem("previousPage") || "Dashbaord";

    const handleTilbakeClick = () => {
        localStorage.removeItem("previousPage");
        setTab(backTo);
    }
    return (
        <button
            className="mb-6 text-slate-500 hover:text-slate-900 text-sm"
            onClick={() => handleTilbakeClick()}
        >
            ← Tilbake til {label}
        </button>
    )
}